import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function AdminLogin() {
  const { status, login } = useAdminAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (status === "authed") navigate("/admin", { replace: true });
  }, [status, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Giriş başarısız. Bilgileri kontrol edin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-charcoal px-4">
      <div className="w-full max-w-sm border border-cream/10 bg-[#221f1d] p-8">
        <div className="mb-7 text-center">
          <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-bordo">
            <Lock className="h-5 w-5 text-cream" />
          </span>
          <h1 className="font-serif text-3xl text-cream">Ertan Kasap</h1>
          <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-copper">Yönetim Paneli</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="username" className="font-mono text-[11px] uppercase tracking-wider text-cream/70">
              Kullanıcı Adı
            </Label>
            <Input
              id="username"
              data-testid="admin-username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              className="mt-1.5 border-cream/15 bg-charcoal text-cream placeholder:text-cream/30"
            />
          </div>
          <div>
            <Label htmlFor="password" className="font-mono text-[11px] uppercase tracking-wider text-cream/70">
              Şifre
            </Label>
            <Input
              id="password"
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="mt-1.5 border-cream/15 bg-charcoal text-cream placeholder:text-cream/30"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="font-mono text-xs text-red-400">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-bordo text-cream hover:bg-bordo-dark"
          >
            {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
          </Button>
        </form>
      </div>
    </div>
  );
}
